<template>
  <ombudsman-view :id="$route.params.id" />
</template>

<script>
import OmbudsmanView from "./OmbudsmanView/OmbudsmanView.vue";

export default {
  name: "OmbudsmanViewWrapper",
  components: {
    OmbudsmanView,
  },
};
</script>
